import { createContext, useContext, type ReactNode } from 'react';
import { hasPermission, type Permission } from '~/lib/permissions';

const PermissionsContext = createContext<Permission[] | null>(null);

export function PermissionsProvider({
  permissions,
  children,
}: {
  permissions: Permission[];
  children: ReactNode;
}) {
  return <PermissionsContext.Provider value={permissions}>{children}</PermissionsContext.Provider>;
}

export function useHasPermission(permission: Permission): boolean {
  const permissions = useContext(PermissionsContext);
  if (permissions === null) {
    return false;
  }
  return hasPermission(permissions, permission);
}
